/**
 * 格式化CSS的工具函数
 */
import { compress } from '@kk/utils';

/**
 * 格式化图片src
 * @param imgWidth 三倍图标准下的图片宽度，默认为全屏宽度，即 375 * 3
 * @param imgUrl 图片src
 */
export function formatImgSrc({ imgWidth = 1125, imgUrl = '' }) {
    if (!imgUrl) return '';
    return compress(imgUrl, (imgWidth / 3) * 2, true, true, 'u');
}
